var path = 'areas/projects/actions/tomcat/Octopus.TomcatState_summary.html';
var html = "<p> Start or stop deployments in Tomcat instances in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/tomcat/Octopus.TomcatState_summary.html
// module id = 1004561943252158
// module chunks = 1